import React from 'react';
import {Typography, Grid} from "@material-ui/core";
import SearchRecipe from "../../components/searchRecipe/SearchRecipe";


/**
 * This class wil be the main page of our app, where we present lot of recipe
 * (daily dishes, list of all ingredients available and recipes depending on your ingredients list)
 */
export default class Search extends React.Component {

    render() {
        return (
            <Grid container justify='center' >
                <Grid container justify='center' spacing={2} style={{margin: 20}}>
                    <Grid item>
                        <Typography> Rechercher </Typography>
                    </Grid>
                    <SearchRecipe/>
                </Grid>
            </Grid>
        );
    }
}

